<template>
  <div class="block_wrap">
    <div class="header">
      <span
          v-if="$store.getters.getPermissions.createUser === true"
          class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
          @click.prevent="new_user()"
      >
          <b>{{ translate('user.to_add') }}</b>
      </span>
    </div>
    <div class="response_table">
      <table>
        <thead :class="{show_th : add_padd}">
          <tr>
            <th scope="col">
              {{ translate('client.users.name') }}
            </th>
            <th scope="col">
              {{ translate('client.users.username') }}
            </th>
            <th scope="col">
              {{ translate('client.users.email') }}
            </th>
            <th scope="col">
              {{ translate('client.users.active') }}
            </th>
            <th scope="col">
              {{ translate('client.users.last_try') }}
            </th>
          </tr>
        </thead>
        <tbody ref="client_users_table_tbody">
          <router-link
            v-for="(user,key) in users"
            :key="key"
            :to="'/user/' + user.username"
            class="user"
          >
            <tr class="pointer">
              <td :data-label="translate('client.users.name')">
                {{ user.name }}
              </td>
              <td :data-label="translate('client.users.username')">
                {{ user.username }}
              </td>
              <td :data-label="translate('client.users.email')">
                {{ user.email }}
              </td>
              <td :data-label="translate('client.users.active')">
                <span class="badge" :style="'background-color: ' + active_user(user.active).color">
                    {{ translate("client.users." + active_user(user.active).title) }}
                  </span>
              </td>
              <td :data-label="translate('client.users.last_try')">
                {{ get_date(user.last_try_ts) }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import EditProfile from "@/views/Dashboard/General/UserManagement/Tabs/UserList/UserProfile/EditUserProfile.vue";

export default {
  name: 'ClientUsers',

  data () {
    return {
      users: [],
      user_actives: [
        {
          "id": 0,
          "title": "not_active",
          "color": "orange"
        },
        {
          "id": 1,
          "title": "active",
          "color": "green"
        }
      ]
    }
  },

  mounted() {
    this.get_client_users()
  },

  computed:{
    add_padd(){
      if (this.$refs.client_users_table_tbody){
        let trs = this.$refs.client_users_table_tbody.querySelectorAll('tr')
        let sum = 0
        for (let tr of trs) {
          sum += tr.offsetHeight
        }
        if (sum > this.$refs.client_users_table_tbody.offsetHeight){
          return true
        }
      }
      return false
    }
  },
  methods: {
    active_user(active_id){
      let active = this.user_actives.find((item) => {
        if (item.id === active_id) return item
      })
      return active ? active : { color: "red", title: "Not Found" }
    },
    cancel () {
      this.$emit('cancel')
    },
    get_client_users () {
      this.$http.v1.getClientUsers(this.$route.params.client_id, (response) => {
        this.users = response.data
      })
    },
    new_user () {
      let val = {
        active: 1,
        email: '',
        client_id: this.$route.params.client_id,
        name: '',
        phone: '',
        username: ""
      }
      let t = this.$createElement(EditProfile, {
        props: {
          user: val,
          role_list: this.role_list,
          permission_list: this.permission_list
        },
        on: {
          close: () => {
            this.$modal.hide('user_profile_modal')
            this.check_link = true
          },
          update: () => { this.$emit('client_update') }
        }
      })
      let temp = {render () { return t }}
      this.$modal.show(temp, {}, {
        height: 800,
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'user_profile_modal'
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    height: 100%;
    .header{
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-end;
      span{
        height: 40px;
      }
    }
    .response_table{
      padding: 0;
      height: calc(100% - 60px);
      table{
        thead {
          tr{
            padding: 0;
          }
          &.show_th{
            tr{
              border-collapse: separate;
              padding-right: 10px;
            }
          }
        }
        tbody{
          &::-webkit-scrollbar{
            width: 10px;
          }
          .user{
            color: #333333;
            &:hover{
              tr{
                background-color: #eee;
              }
            }
          }
        }
      }
    }
  }



</style>
